import authentication from './authentication/reducer';
import alerts from './alerts/reducer';

const reducers = {
	authentication,
	alerts
};

export default reducers;
